import JSONModel from "sap/ui/model/json/JSONModel";
import { Routes } from "../../constants/Routes";
import BaseController from "../sharedControllers/BaseController";

/**
 * @namespace akademika.akamont.pages.userDetailsAdmin
 */

export default class UserDetailsAdmin extends BaseController {
  route = Routes.USER_DETAILS_ADMIN;
  parentRoute = Routes.USER_LIST;

  public async onRouteMatched() {
    this.setModel(
      new JSONModel({
        edit: false,
      }),
      "viewOptions"
    );
    await this.getUserDetails();
  }

  public async getUserDetails() {
    await this.fetchModel(
      "api/User/GetUserDetailsForAdmin/" + this.routeParams.userId
    );
  }

  public async onEditUser() {
    const viewOptionsModel = this.getModel("viewOptions");
    let editValue = viewOptionsModel.getProperty("/edit");
    viewOptionsModel.setProperty("/edit", !editValue);

    if (editValue) {
      await this.getUserDetails();
    }
  }

  public async onSaveUser() {
    await this.saveDataAndShowMessage("api/User/UpdateUserForAdmin", {
      body: this.getModelData(),
    });

    this.getModel("viewOptions").setProperty("/edit", false);
    await this.getUserDetails();
  }
}
